const Translation = {
    title: "WAEI.INC",
    nav: {
        about: "About",
        contact: "Contact",
    },
    about: {
        title: "ABOUT",
        desc_1: "WAEI.INC is a film and commercial production company based in Tokyo, Japan and Beijing, China.",
        desc_2: "Relying on the mature experience in film and advertising, while developing advertising business in Japan, he is committed to producing Sino-Japanese co-productions, making the contribution that a filmmaker should make to the everlasting friendship between the two countries."
    },
    contact: {
        title: "CONTACT",
        desc_1: "Han Mengxin",
        desc_2: "TEL: +81 03-6914-4070 / +81 080-6501-0978",
        desc_3: "E-MAIL: mengxin_han@waei.one",
        desc_4: "ADDRESS: 东京都世田谷区楼 3-29-4-101",
    },
    article: {
        rental_price: "Rental Price",
        characteristic: "CHARACTERISTIC",
        accessories: "ACCESSORIES",
        specification: "SPECIFICATION",
        related_equipment: "RELATED EQUIPMENT",
    },
    common: {
        more: "MORE",
    },
}

export default Translation;
